import { gql } from 'apollo-angular';

export const CREATE_CUSTOM_REMINDER = gql`
  mutation createCustomReminder($input: CreateCustomReminderInput!) {
    createCustomReminder(input: $input) {
      id
      title
      description
      targetType
    }
  }
`;
export const UPDATE_CUSTOM_REMINDER = gql`
  mutation updateCustomReminder($id: Int!,$input: UpdateCustomReminderInput!) {
    updateCustomReminder(id: $id,input: $input) {
      id
      title
      description
      targetType
    }
  }
`;

export const REMOVE_CUSTOM_REMINDER = gql`
  mutation removeCustomReminder($id: Int!) {
    removeCustomReminder(id: $id)
  }
`;